import React from 'react';
import "./mainservicepage.css";
import image1 from "../../assets/gallery/c1.jpeg";
import image2 from "../../assets/gallery/real2.jpeg";

function Mainservicepage() {
    return (
        <>
         <div className="section-title clearfix d-flex flex-column align-items-center"
        >
                    <div class="title-header">
                        <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>OUR SERVICES</h5>
                        {/* <h3>New Sky Property & Projects Private Limited (NSPP)</h3> */}
                    </div>
                    <div className='underline' style={{ width: "8%" }} ></div>
                </div>
            <div className="container--main">
               
                <div className="image-wrapper">
                    <img src={image1} alt="Avatar" className="image-mainservice" />
                    <div className="overlay-mainservice">
                        <h4><b>Construction Service</b>
                        </h4>
                        <p>At New Sky Property and Projects Pvt. Ltd., we offer end-to-end construction
                            solutions for residential, commercial, and industrial projects. From architectural
                            planning to final handover, we ensure every structure is built with precision,
                            high-quality materials, and expert craftsmanship. Our experienced team of engineers,
                            site supervisors, and certified contractors work closely with clients to deliver proj
                            ects on time, within budget, and with a strong focus on durability and safety. Whe
                            ther it's a custom home, retail complex, or multi-storey apartment, we turn your
                            vision into reality with professionalism and pride.</p>
                    </div>
                </div>

                <div className="image-wrapper">
                    <img src={image2} alt="Avatar" className="image-mainservice" />
                    <div className="overlay-mainservice">
                        <h4><b> Real Estate Services</b></h4>
                        <p>At New Sky Property and Projects Pvt. Ltd., our real estate division
                            provides trusted support for buying, selling, and developing land and built-u
                            p properties. We manage everything from property sourcing and legal verification to
                            documentation clearance, registration, and project marketing. Whether it's a vacant pl
                            ot, commercial space, or apartment project, our team ensures every transaction is smoo
                            th, transparent, and secure. Backed by legal advisors and market specialists, we guide
                            our clients
                            to make confident, value-driven property decisions..</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Mainservicepage;
